<template>
  <v-container fill-height fluid>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <Login></Login>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Login from "@/components/Login";

export default {
  components: {
    Login
  }
};
</script>
